<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.num')">
                    <el-select
                      v-model="formInline.selectCarType"
                      style="width: 120px"
                      :placeholder="$t('common.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.selectCarValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('GovernmentRegulation.insureType')">
                    <el-select
                      v-model="formInline.insuranceState"
                      :placeholder="$t('VehicleManagement.isInsureState')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in StateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.insureStartTime')">
                    <el-date-picker
                      v-model="formInline.insureStartTime"
                      type="daterange"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.btn.choseDate')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.insureEndTime')">
                    <el-date-picker
                      v-model="formInline.insureEndTime"
                      type="daterange"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.btn.choseDate')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('INSUREFILE_EDIT')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editCar"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button v-if="isPrimaryKey('INSUREFILE_IMPORT')" type="text" @click="BulkImport">{{$t('common.btn.upload')}}</el-button>
                <el-button v-if="isPrimaryKey('INSUREFILE_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="750px"
        :before-close="closeDia"
        class="carDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="insureStartTime"
            :label="$t('VehicleManagement.insureStartTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.btn.choseDate')"
              v-model="form.insureStartTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="insureEndTime"
            :label="$t('VehicleManagement.insureEndTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.btn.choseDate')"
              v-model="form.insureEndTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="insureFilePath"
            :label="$t('common.btn.uploadFile')+':'"
            :label-width="formLabelWidth"
          >
            <input
              @change="uploadFiles()"
              id="uploadFile"
              type="file"
              style="display: none;"
            />
            <el-button type="primary" size="small" @click="triggerFileUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeBatchDia"
        :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible"
        class="batchDialong"
        :close-on-click-modal="false"
      >
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()"
            >{{$t('common.btn.downloadModelFile')}}</el-button
                >
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{$t('common.btn.clickUploadFile')}}</div>
          <input @change="uploadCar" id="uploadDom" type="file" style="display: none;" />
          <el-button type="primary" size="small" @click="triggerBatchUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del"
            >{{$t('common.btn.cancel')}}</el-button
                >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import InsureFile from "./InsureFile.js";
export default InsureFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
